var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ContractorsDocumentsFilteredList", {
    attrs: {
      companyId: _vm.company.id,
      currentUser: _vm.currentUser,
      queryObject: _vm.queryObject,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }